import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getRoutePathById, allSiteMap } from '@bingads-webui-react/with-site-map';

import { IOverviewTableProps, IScopeContext } from './types';
import { GridDataTable } from './grid-data-table';
import { useStyles } from './overview-grid-card-style';

export function OverviewAdGroupTable(props: IOverviewTableProps) {
  const { i18n } = props;
  const { scope } = useContext(ScopeContext) as IScopeContext;
  const classes = useStyles();
  const {
    aid, cid, uid, campaignId,
  } = scope?.values;

  const onFooterButtonClick = useCallback(() => {
    scope.save(getRoutePathById(allSiteMap, 'adgroups'));
  }, [scope]);

  const getHref = useCallback((entityId: string) => {
    const route = getRoutePathById(allSiteMap, 'keywords');
    const search = `cid=${cid}&uid=${uid}&aid=${aid}&campaignId=${campaignId}&adGroupId=${entityId}`;
    return `${route}?${search}`;
  }, [aid, cid, uid, campaignId]);

  return (
    <div className={classNames(classes.gridStyle, 'ba-ad-group-overview-table')}>
      <GridDataTable
        {...props}
        entityDisPlayName={i18n.getString(_TL_('Ad groups'))}
        footerButtonConfigs={[
        {
          text: i18n.getString(_TL_('View all ad groups')),
          onClick: onFooterButtonClick,
        },
      ]}
        getHref={getHref}
        entityType="AdGroup"
      />
    </div>
  );
}

